module.exports = __webpack_public_path__ + "img/rs_pinkL-logo.f8f8a3c.png";